import React from 'react';
import {ScoreRankBadge} from './ScoreRankBadge';

interface ScoreChangeIndicatorProps {
  fromRank: string | null | undefined;
  toRank: string | null | undefined;
  fromScore: number | null | undefined;
  toScore: number | null | undefined;
}

export const ScoreChangeIndicator: React.FC<ScoreChangeIndicatorProps> = ({
  fromRank,
  toRank,
  fromScore,
  toScore,
}) => {
  const scoreDiff = (toScore || 0) - (fromScore || 0);

  return (
    <div className="flex items-center gap-1">
      <ScoreRankBadge rank={fromRank} className="bg-gray-100 text-gray-500" />
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 5.33331L14.6667 7.99998L12 10.6666"
          stroke="#999999"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.3335 8H14.6668"
          stroke="#999999"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <ScoreRankBadge rank={toRank} />
      <span
        className={`text-sm font-bold ml-2 ${
          scoreDiff > 0 ? 'text-green-600' : 'text-red-600'
        }`}>
        {scoreDiff > 0 ? '+' : ''}
        {scoreDiff}
      </span>
    </div>
  );
};